// Site search
const siteSearch = ( function() {

	/**
	 * Vars
	 */
	let
		_instance          = {},
		$searchForms       = document.querySelectorAll( '.search-form' ),
		$searchFormButtons = document.querySelectorAll( '.search-form .search-form__button' ),
		$searchFormInputs = document.querySelectorAll( '.search-form .search-form__input' ),
		$classActive = 'form-active';

		//Search form at news page
	let $searchInputClear = document.querySelectorAll( '.searchform__form .clear' );

	/**
	 * Init any binding and attributes for all elements.
	 */
	let init = function() {

		// Document click to close all forms
		document.addEventListener( 'click', documentClick );

		// Loop through all the buttons and setup a11y and binding.
		for ( let index = 0; index < $searchFormButtons.length; index++ ) {
			let
				$element         = $searchFormButtons[index];

				// Setup binding
				$element.addEventListener( 'click', searchFormButtonClick );
		}

		// Loop through all the search input and setup keyup events
		for ( let index = 0; index < $searchFormInputs.length; index++ ) {
			let
				$element         = $searchFormInputs[index];

			// Setup binding
			$element.addEventListener( 'keyup', searchFormInputKeyup );
		}

		// Loop through all the search input and active clear user query
		for ( let index = 0; index < $searchInputClear.length; index++ ) {
			let
				$element         = $searchInputClear[index];

			// Setup binding
			$element.addEventListener( 'click', searchRequestClear );
		}
	};

	/**
	 *  Check enter key on search form
	 */
	let searchFormInputKeyup =  function( e ) {

		// Stop the default submit event.
		e.preventDefault();

		let
			$element         = this,
			$searchForm      = $element.parentNode,
			$searchFormInput = $searchForm.querySelector( '.search-form__input' ),
			searchQuery      = $searchFormInput.value.trim();

		if ( 13 === e.which && searchQuery ) {
			$searchForm.submit();
		}
	};

	/**
	 *  Clear all user request inside search input
	 */
	let searchRequestClear = function( event ) {
		event.target.nextElementSibling.value = '';
	};

	/**
	 * Handles the search form button click event.
	 * Opens the form when closed, submits if there is a query or closes.
	 * @param {Object} event The event object.
	 */
	let searchFormButtonClick = function( event ) {
		let
			$element         = this,
			$searchForm      = $element.parentNode;

		// Stop the default submit event.
		event.preventDefault();

		// If the form is open...
		if ( $searchForm.classList.contains( $classActive ) ) {

			// Close the search form.
			searchFormClose( $searchForm );
		} else {

			// Open the form
			searchFormOpen( $searchForm );
		}
	};

	/**
	 * Opens the specified search form.
	 * @param {Element}  $searchForm The element search form to use (required).
	 */
	let searchFormOpen = function( $searchForm ) {
		$searchForm.classList.add( 'form-active' );
	};

	/**
	 * Closes the specified search form.
	 * @param {Element}  $searchForm The element search form to use (required).
	 */
	let searchFormClose = function( $searchForm ) {
		$searchForm.classList.remove( 'form-active' );
	};

	/**
	 * When the document is clicked, close all the forms.
	 */
	let documentClick = function( event ) {

		if ( ! event.target.closest( '.search-form' ) ) {

			// Loop through all forms.
			for ( let index = 0; index < $searchForms.length; index++ ) {
				const $searchForm = $searchForms[index];


				// Close the form.
				// Do not move focus though.
				searchFormClose( $searchForm );
			}
		}
	};

	/**
	 * Public
	 */
	_instance.init = function() {
		init();
	};

	return _instance;
}() );

// Export
export default siteSearch;
